module.exports = "static/assets/9c0ac6e5681567da6d6f6004ba107658.svg";